<template>
    <div class="start">
        <div class="container">
            <p class="start__title">Witamy w Krainie ABC</p>
            <p class="start__subtitle">Załóż konto dziecku, aby dostosować parametry do wieku dziecka i&nbsp;zarządzać ustawieniami.</p>

            <div class="start__elements">
                <LetterP class="start__img"></LetterP>

                <div class="start__adding" @click="addSubProfile">
                    <IconAdd class="start__adding-icon"></IconAdd>
                    <span class="start__adding-text">Dodaj profil dziecka</span>
                </div>

                <LetterZ class="start__img"></LetterZ>
            </div>

            <router-link class="start__btn" to="/"><span>Nie teraz</span></router-link>

            <LetterP class="start__img start__img--mobile"></LetterP>

            <transition-group name="fade" appear>
                <ProfileAvatarList v-if="isModalAvatar" @closeModal="closeModal"></ProfileAvatarList>
            </transition-group>
        </div>

        <LoginPIN v-if="isModalPin" @modalPinToggle="modalPinToggle"></LoginPIN>
        <ModalConsent v-if="isModalConsent" @consentHandle="consentHandle"></ModalConsent>
    </div>
</template>

<script>
import axios from "axios";
import IconAdd from "../elements/icons/IconAdd.vue";
import LetterP from "../elements/icons/letters/LetterP.vue";
import LetterZ from "../elements/icons/letters/LetterZ.vue";
import ProfileAvatarList from "../profile/ProfileAvatarList.vue";
import LoginPIN from "../login/LoginPIN.vue";
import ModalConsent from "../modals/ModalConsent.vue";
import { useToast } from "vue-toastification";
const toast = useToast()

export default {
    name: "ProfileStart",
    components: {
        IconAdd,
        LetterP,
        LetterZ,
        ProfileAvatarList,
        LoginPIN,
        ModalConsent
    },
    data() {
        return {
            CONSENT_ALLOW: '/api/krainaabc/account/user-application-data/consent-allow?device=www',
            isModalAvatar: false,
            isModalPin: false,
            isModalConsent: false
        };
    },
    computed: {
        globalUserData() {
            return this.$store.getters.getGlobalUserData;
        }
    },
    methods: {
        addSubProfile() {
            if(this.globalUserData && !this.globalUserData.subprofile_process_consent) {
                this.isModalConsent = true;
            } else if (this.globalUserData && this.globalUserData.has_pin === false) {
                this.isModalPin = true;
            } else {
                this.isModalAvatar = true;
            }

            this.$store.dispatch("changeModalBackdrop", true);
        },
        closeModal() {
            this.isModalAvatar = false;
            this.$store.dispatch("changeModalBackdrop", false);  
        },
        modalPinToggle(pin) {
            this.isModalPin = false;
            if(pin) {
                this.isModalAvatar = true;
            } else {
                this.$store.dispatch("changeModalBackdrop", false);
            }
        },
        consentHandle(value) {
            this.isModalConsent = false;

            if(value) {
                this.saveConsentAllow();

                if(this.globalUserData && this.globalUserData.has_pin === false) {
                    this.isModalPin = true;
                } else {
                    this.isModalAvatar = true;
                }
            }  else {
                this.$store.dispatch("changeModalBackdrop", false);
            }
        },
        saveConsentAllow() {
            axios
                .post(this.CONSENT_ALLOW)
                .then((response) => {
                    if(response.data.data.success) {
                        toast.success("Zgody zostały zapisane"); 
                        this.$store.dispatch('globalUserData');
                    } else {
                        toast.error("Nie udało się zapisać zgód");
                    }
                })
                .catch(() => {
                    toast.error("Nie udało się zapisać zgód");
                }); 
        }          
    }
};
</script>